var Findation = window.Findation || {};
// eslint-disable-next-line no-use-before-define
var prodcat = prodcat || {};
// eslint-disable-next-line no-use-before-define
var site = site || {};

prodcat.data = prodcat.data || {};

site.translations = site.translations || {};

(function ($, ServiceBus, Topics) {
  'use strict';

  // Set a hasAccess boolean variable which defaults to false except for
  // browsers which don't support the API - where we assume
  // such browsers also don't block third-party cookies.
  let hasAccess = false;

  async function hasCookieAccess() {
    // Check if Storage Access API is supported
    if (!document.requestStorageAccess) {
      // Storage Access API is not supported so best we can do is
      // hope it's an older browser that doesn't block 3P cookies.
      console.log('not supported');
      return true;
    }

    // Check if access has already been granted
    if (await document.hasStorageAccess()) {
      console.log('already has access');
      return true;
    }

    // Check the storage-access permission
    // Wrap this in a try/catch for browsers that support the
    // Storage Access API but not this permission check
    // (e.g. Safari and earlier versions of Firefox).
    let permission;
    try {
      permission = await navigator.permissions.query(
        {name: 'storage-access'}
      );
    } catch (error) {
      // storage-access permission not supported. Assume no cookie access.
      return false;
    }

      if (permission) {
      if (permission.state === 'granted') {
        // Permission has previously been granted so can just call
        // requestStorageAccess() without a user interaction and
        // it will resolve automatically.
        try {
          await document.requestStorageAccess();
          return true;
        } catch (error) {
          // This shouldn't really fail if access is granted, but return false
          // if it does.
          return false;
        }
      } else if (permission.state === 'prompt') {
        // Need to call requestStorageAccess() after a user interaction
        // (potentially with a prompt). Can't do anything further here,
        // so handle this in the click handler.
        return false;
            } else if (permission.state === 'denied') {
              // Not used: see https://github.com/privacycg/storage-access/issues/149
        return false;
            }
      }

    // By default return false, though should really be caught by earlier tests.
    return false;
  }

  let sdIntervalTries = 0;
  const isIframe = window.location !== window.parent.location;
  const sdServicesInterval = setInterval(sdServicesTimer, 1000);

  const isIos = function () {
    // Using same check as Findation JS is using, for IOS workaround.
    var userAgent = window.navigator.userAgent;

    return userAgent.match(/iPad/i) || userAgent.match(/iPhone/i);
  };

  function sdServicesTimer() {
    if (!isIos) {
      // Only need this work around for IOS, since findation iframe get's diff styling.
      clearInterval(sdServicesInterval);

      return;
    }
    ServiceBus = window.GlobalServiceBus || ServiceBus;
    Topics = window.ServiceBusTopics || Topics;

    if (ServiceBus && Topics?.events?.FINDATION_BUTTON_CLICKED) {
      clearInterval(sdServicesInterval);
      ServiceBus.on(Topics?.events?.FINDATION_BUTTON_CLICKED, function () {
        $('html').addClass('findation-widget--initialised');
        setTimeout(() => {
          $('html').removeClass('findation-widget--initialised');
        }, '3000');
      });
    }
    if (sdIntervalTries === 7) {
      // If we tried 7 times and the ServiceBus or Topics are not available we break interval.
      clearInterval(sdServicesInterval);
    }
    sdIntervalTries++;
  }

  const goTo = function (url) {
    window.location.href = url;
  };
  const goToOnParent = function (url) {
    window.parent.location.href = url;
  };
  const setShade = function (shadeName) {
    const $shadeGrid = $('.js-product-full__shades-container');

    if ($shadeGrid.length > 0) {
      $shadeGrid.find('[data-shade-name="' + shadeName + '"]').trigger('click');
    }
  };
  const setShadeOnParent = function (shadeName) {
    const $shadeGrid = $('.js-product-full__shades-container', window.parent.document);

    if ($shadeGrid.length > 0) {
      $shadeGrid.find('[data-shade-name="' + shadeName + '"]').trigger('click');
    }
  };
  const changeSku = function (productCode) {
    const $shadeGrid = $('.js-product-full__shades-container');

    if ($shadeGrid.length > 0) {
      $shadeGrid.find('[data-product-code="' + productCode + '"]').trigger('click');
    }
  };
  const changeSkuOnParent = function (productCode,) {
    const postMsg = {
      _elc_action: 'selectShade',
      skuBaseId: productCode
    }

    window.parentIFrame.sendMessage(postMsg, '*');
  };

  const triggerEvent = function (value) {
    const parts = value.split('||');
    const eventName = parts[0];
    const eventPayload = parts[1] || {};

    switch (eventName) {
      case 'live_chat': {
        const $elem = $(eventPayload);

        if ($elem.length > 0) {
        // Keep HTML elem .click(), doesn't work with jQuery.
          $elem[0].click();
        }
        break;
      }
      default:
        $(document).trigger(eventName, eventPayload);
    }
  };

  const triggerEventOnParent = function (value) {
    const parts = value.split('||');
    const eventName = parts[0];
    const eventPayload = parts[1] || {};

    switch (eventName) {
      case 'live_chat': {
        isVulcan() && window.parentIFrame.sendMessage({_elc_action: 'openSalesforceChat'}, '*');
      }
        break;
      case 'open_live_chat':
        window.parentIFrame.sendMessage({ _elc_action: 'openLiveChat' }, '*');
        break;
      default:
        $(window.parent.document).trigger(eventName, eventPayload);
    }
  };
  const scrollIntoViewOnParent = function (scrollY) {
    const postMsg = {
      _elc_action: 'scrollIntoView',
      scrollY: scrollY
    };

    window.parentIFrame.sendMessage(postMsg, '*');
  };
  const findationWidgetOnParent = function () {
    const postMsg = {
      _elc_action: 'findationWidget'
    };

    window.parentIFrame.sendMessage(postMsg, '*');
  };
  const analyticsOnParent = function (analyticsAction) {
    const postMsg = {
      _elc_action: 'findationWidget',
      _elc_analytics_action_name: analyticsAction
    };

    window.parentIFrame.sendMessage(postMsg, '*');
  };

  $(document).on('findation-initialised', function () {

    Findation.onActionReceived = function (payload) {
      const parts = payload.split('::');
      const action = parts[0];
      const value = parts[1];

      switch (action) {
        case 'goTo':
          !isIframe && goTo(value);
          isIframe && goToOnParent(value);
          break;
        case 'setShade':
          !isIframe && setShade(value);
          isIframe && setShadeOnParent(value);
          break;
        case 'changeSku':
          !isIframe && changeSku(value);
          isIframe && changeSkuOnParent(value);
          break;
        case 'event':
          !isIframe && triggerEvent(value);
          isIframe && triggerEventOnParent(value);
          break;
        case 'scrollIntoView':
          isIframe && scrollIntoViewOnParent(value);
          break;
        case 'findationWidget':
          isIframe && findationWidgetOnParent(value);
          break;
        case 'analytics':
          isIframe && analyticsOnParent(value);
          break;
        default:
      }
    };

    Findation.resultsWillRender = function (html) {
      var isCrossSell = $(html).data().crossSell;
      var productCode = $(html).data().productCode;
      var findationGetCrossSellSku = function () {};
      var findationCrossSellSkus = Drupal?.settings?.findation_cross_sell_skus || {};
      var translationKeyCrossSellShop = site?.translations?.product?.findation_cross_sell_shop_cta_label || 'SHOP';
      var translationKeyCrossSellHeading = site?.translations?.product?.findation_cross_sell_heading || 'Your nude lipstick shade match is:';
      var siteUrl = Drupal?.settings?.mac?.host || '';
      var shadeNameRouter = '';
      var crossSellHtml = $();
      var skuData;
      var productData;
      var newHtml;

      if (!isCrossSell) {
        return html;
      }
      findationGetCrossSellSku = _.filter(findationCrossSellSkus, function (crossSellSku, sku) {
        if (sku === productCode) {
          return crossSellSku;
        }
      });
      skuData = prodcat.data.getSku(findationGetCrossSellSku[0]);
      productData = prodcat.data.getProduct(skuData.PRODUCT_ID);
      shadeNameRouter = encodeURIComponent(skuData.SHADENAME?.replace(/ /g, '_'));
      crossSellHtml = `<p>${translationKeyCrossSellHeading}</p>
                      <h1 class="body-text--bold">${skuData.SHADENAME}</h1>
                      <h2 class="body-regular--gray">${productData.PROD_RGN_NAME}</h2>
                      <a class="btn btn-primary"
                      href="https://${siteUrl}${productData.url}?shade=${shadeNameRouter}&findation_cross_sell"
                      target="_blank">
                        ${translationKeyCrossSellShop}
                      </a>`;

      newHtml = html.replace(/<cross-sell-html>/, crossSellHtml);

      return newHtml;
    };

    Findation.widgetEmbedded = function () {
      if (!isIframe) {
        return;
      }
      analyticsOnParent('findation-widget-presented');
    };

    Findation.widgetDidOpen = function () {
      if (!isIframe) {
        return;
      }
      analyticsOnParent('findation-widget-opened');
    };

    Findation.widgetDidClose = function () {
      if (!isIframe) {
        return;
      }
      analyticsOnParent('findation-widget-closed');
    };

    Findation.onSearchComplete = function (data) {
      if (!isIframe) {
        return;
      }

      if (data.matchSuccess) {
        analyticsOnParent('findation-widget-recommendation-results');
      } else {
        analyticsOnParent('findation-widget-no-results');
      }
    };
  });

  const isVulcan = function() {
    return window.parent._platform === 'vulcan';
  }

  const translateFindationKey = function(findationKey) {
    let browserLanguage = $('html').attr('lang');
    let useTranslation = document.location.hostname.indexOf('fr.maccosmetics.ca') !== -1 ? 'fr_CA' : browserLanguage?.replace('-', '_') || null;
    let findationConfig = Drupal?.settings?.findation || {};
    const locale = $.cookie('LOCALE');
    const translatedKeys = (useTranslation && findationConfig[useTranslation]) || (locale && findationConfig[locale]);
    return (translatedKeys && translatedKeys[findationKey]) || findationKey;
  }
  const translateWidgets = function() {
    const $findationTout = $('.js-third-party-tout__wrapper');
    const $findationBanner = $('.js-promo-banner__inner');
    if ($findationTout.length > 0) {
      const toutKey = $findationTout.data('toutKey');
      $findationTout.attr('data-tout-key', translateFindationKey(toutKey));
    }
    if ($findationBanner.length > 0) {
      const bannerKey = $findationBanner.data('findationKey');
      $findationBanner.attr('data-tout-key', translateFindationKey(bannerKey));
    }
  }
  const setClickEvents = function () {
    var $findationWidget = $('.js-third-party-tout__wrapper');
    var $findationCta = $('.js-third-party-tout__cta');
    var findationKey = $findationWidget.length > 0 ? $findationWidget.attr('data-tout-key') : null;
    var options = {};
    var selector = !isIframe ? '.js-product-full__addtobag-block' : '.js-third-party-tout__wrapper';
    $findationCta.once().on('click', async function (e) {
      e.preventDefault();
      var hasAccess = !isIframe || await hasCookieAccess();

      if (hasAccess) {
        // Grab the key again, changes on translated sites.
        findationKey = $findationWidget.attr('data-tout-key');
        if (isIframe) {
          options = {
            productUrl: decodeURI(window.parent.document.location.href)
          }
        }
        $(document).trigger('findation-load', {findationKey: findationKey, selector, options});
        $('html, body').animate({ scrollTop: 0 }, 500);
      }
    });
  }
  $(function () {
    translateWidgets();
    setClickEvents();
    const locationHref = !isIframe ? window.location.href : window.parent.document.location.href;
    const autoTriggerFindation = locationHref.indexOf('shadematch_open') !== -1;

    // Get the findation widget from mount point wrapper.
    // so we can deeplink before SD fully loads.
    const findationKey = $('.js-promo-banner__inner').data('findationKey') || $('.js-third-party-tout__wrapper').data('toutKey');
    const selector = !isIframe ? '.js-product-full__addtobag-block' : '.js-third-party-tout__wrapper';
    const options = {
      productUrl: decodeURI(locationHref)
    };

    if (!autoTriggerFindation && findationKey && isIframe) {
      // Preload the Findation widget when it's inside an iFrame.
      // The banner hides on click, and first load creates a bad UX.
      $(document).trigger('findation-preload', {
        findationKey: translateFindationKey(findationKey),
        selector,
        options
      });
    }
    if (!autoTriggerFindation || !findationKey) {
      return;
    }
    $(document).trigger('findation-load', {
      findationKey: translateFindationKey(findationKey),
      selector,
      options
    });
  });
  
})(jQuery, window.GlobalServiceBus || {}, window.ServiceBusTopics || {});

